var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.pageCount > 1
    ? _c(
        "ul",
        { staticClass: "pagination" },
        [
          _c(
            "li",
            { staticClass: "pagination__item" },
            [
              _c(
                "nuxt-link",
                {
                  class: [
                    "pagination__btn",
                    { "pagination__btn--disabled": _vm.current == 1 }
                  ],
                  attrs: { to: _vm.basePath + "&page=" + _vm.prevPage },
                  nativeOn: {
                    click: function($event) {
                      return _vm.onClick($event)
                    }
                  }
                },
                [
                  _c("icon-arrow", {
                    staticClass: "pagination__btn-icon",
                    attrs: { mod: "left", type: "thin" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.current >= 3 && _vm.pageCount > 3
            ? _c(
                "li",
                { staticClass: "pagination__item" },
                [
                  _c(
                    "nuxt-link",
                    {
                      staticClass: "pagination__link",
                      attrs: { to: _vm.basePath + "&page=" + 1 },
                      nativeOn: {
                        click: function($event) {
                          return _vm.onClick($event)
                        }
                      }
                    },
                    [_vm._v("1\n\t\t")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.current >= 4
            ? _c("li", { staticClass: "pagination__item" }, [_vm._v("...")])
            : _vm._e(),
          _vm._l(_vm.items, function(item) {
            return _c(
              "li",
              { staticClass: "pagination__item" },
              [
                _c(
                  "nuxt-link",
                  {
                    class: [
                      "pagination__link",
                      { "pagination__link--active": _vm.current == item }
                    ],
                    attrs: { to: _vm.basePath + "&page=" + item },
                    nativeOn: {
                      click: function($event) {
                        return _vm.onClick($event)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item) + "\n\t\t")]
                )
              ],
              1
            )
          }),
          _vm.current < _vm.pageCount - 2
            ? _c("li", { staticClass: "pagination__item" }, [_vm._v("...")])
            : _vm._e(),
          _vm.current < _vm.pageCount - 1 && _vm.pageCount > 3
            ? _c(
                "li",
                { staticClass: "pagination__item" },
                [
                  _c(
                    "nuxt-link",
                    {
                      staticClass: "pagination__link",
                      attrs: { to: _vm.basePath + "&page=" + _vm.pageCount },
                      nativeOn: {
                        click: function($event) {
                          return _vm.onClick($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.pageCount) + "\n\t\t")]
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "li",
            { staticClass: "pagination__item" },
            [
              _c(
                "nuxt-link",
                {
                  class: [
                    "pagination__btn",
                    {
                      "pagination__btn--disabled": _vm.current == _vm.pageCount
                    }
                  ],
                  attrs: { to: _vm.basePath + "&page=" + _vm.nextPage },
                  nativeOn: {
                    click: function($event) {
                      return _vm.onClick($event)
                    }
                  }
                },
                [
                  _c("icon-arrow", {
                    staticClass: "icon-arrow--thin pagination__btn-icon",
                    attrs: { mod: "right", type: "thin" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25548396", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25548396","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Pagination.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-25548396","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Pagination.vue
// module chunks = 0